import React from 'react';
import { Layout } from 'antd';
import ErrorDiagnosticsPanel from '@components/error-diagnostics-panel';
import usePageTitle from '@src/hooks/usePageTitle';

const ErrorDiagnostics = (props) => {
  usePageTitle({ text: 'Error Diagnostics' });

  return (
    <>
      <Layout.Content className="container">
        <ErrorDiagnosticsPanel {...props} />
      </Layout.Content>
    </>
  );
};

export default ErrorDiagnostics;
